<template>
    <div class="m-2">
        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Активен</span>
            <span class="w-2/3">
                <CBadge :color="entity.enabled ? 'success' : 'secondary'">
                    {{ entity.enabled ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>
        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Для главной страницы</span>
            <span class="w-2/3">
                <CBadge :color="entity.for_main_page ? 'success' : 'secondary'">
                    {{ entity.for_main_page ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Для карусели подборок</span>
            <span class="w-2/3">
                <CBadge :color="entity.for_selection_carousel ? 'success' : 'secondary'">
                    {{ entity.for_selection_carousel ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Показывать баннер "Что есть в МИРСИТИ"</span>
            <span class="w-2/3">
                <CBadge :color="entity.for_mircity_banner ? 'success' : 'secondary'">
                    {{ entity.for_mircity_banner ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Скрывать главный банер</span>
            <span class="w-2/3">
                <CBadge :color="entity.hide_main_banner ? 'success' : 'secondary'">
                    {{ entity.hide_main_banner ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Показывать попап на главной</span>
            <span class="w-2/3">
                <CBadge :color="entity.for_popup_banner ? 'success' : 'secondary'">
                    {{ entity.for_popup_banner ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Показывать в блоке ЛП</span>
            <span class="w-2/3">
                <CBadge :color="entity.for_assistant_block ? 'success' : 'secondary'">
                    {{ entity.for_assistant_block ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Версии показа</span>
            <span class="w-2/3">
                {{ entity.start_version ? ` с ${entity.start_version}` : '' }}{{ entity.finish_version ? ` по ${entity.finish_version}` : '' }}
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Место показа</span>
            <span class="w-2/3">{{ routeNamesMap[entity.route_name] }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Код AppsFlyer</span>
            <span class="w-2/3">{{ entity.code }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Название акции</span>
            <span class="w-2/3">{{ entity.title }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Описание акции</span>
            <span class="w-2/3">{{ entity.description }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Позиция показа</span>
            <span class="w-2/3">{{ noneZero(entity.place) }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Лимит показа банера</span>
            <span class="w-2/3">{{ noneZero(entity.max_shown_count) }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Пауза между показами баннера</span>
            <span class="w-2/3">{{ noneZero(entity.shown_delay) }} сек</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Основной текст</span>
            <span class="w-2/3">{{ entity.main_text }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Дополнительный текст</span>
            <span class="w-2/3">{{ entity.additional_text }}</span>
        </div>

        <div class="overflow-hidden border border-gray-300 rounded-md p-2 mt-4 mb-4">
            <div class="flex items-center">
                <span class="w-1/3 font-bold">Тип контента</span>
                <span class="w-2/3"><b>{{contentTypesMap[entity.content_type]}}</b></span>
            </div>
            
            <template v-if="entity.content_type === 'image'">
                <div class="flex items-center mt-4">
                    <span class="w-1/3 font-bold">Картинка основная</span>
                    <span class="w-2/3"><CImg
                        :src="pictureUrl(entity.picture)"
                        class="m2"
                        width="200" /></span>
                </div>

                <div class="flex items-center mt-4">
                    <span class="w-1/3 font-bold">Картинка для десктопа</span>
                    <span class="w-2/3"><CImg
                        :src="pictureUrl(entity.desktop_picture)"
                        class="m2"
                        width="200" /></span>
                </div>

                <div class="flex items-center mt-4">
                    <span class="w-1/3 font-bold">Картинка для подборки</span>
                    <span class="w-2/3"><CImg
                        :src="pictureUrl(entity.selection_picture)"
                        class="m2"
                        width="200" /></span>
                </div>

                <div class="flex items-center mt-4">
                    <span class="w-1/3 font-bold">Картинка для главной (большая)</span>
                    <span class="w-2/3"><CImg
                        :src="pictureUrl(entity.picture_main_page)"
                        class="m2"
                        width="200" /></span>
                </div>

                <div class="flex items-center mt-4">
                    <span class="w-1/3 font-bold">Картинка для главной (маленькая)</span>
                    <span class="w-2/3"><CImg
                        :src="pictureUrl(entity.picture_main_page_sq)"
                        class="m2"
                        width="200" /></span>
                </div>
            </template>
            
            <template v-if="['video_mp4', 'video_webm'].includes(entity.content_type)">
                <div class="flex items-center mt-4">
                    <span class="w-1/3 font-bold">Постер</span>
                    <span class="w-2/3"><CImg
                        :src="pictureUrl(entity.picture)"
                        class="m2"
                        width="400" /></span>
                </div>
                <div class="flex items-center mt-4">
                    <span class="w-1/3 font-bold">Видео</span>
                    <span class="w-2/3">
                        <video 
                            playsinline 
                            autoplay 
                            muted 
                            loop 
                            width="400"
                            :poster="pictureUrl(entity.picture)">
                            <source :src="pictureUrl(entity.video)" v-if="entity.content_type === 'video_mp4'" type="video/mp4">
                            <source :src="pictureUrl(entity.video)" v-if="entity.content_type === 'video_webm'" type="video/webm">
                        </video>
                    </span>
                </div>
            </template>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Расширенное время показа (Пример: с 07:00, до 02:00 след. дня)</span>
            <span class="w-2/3">
                <CBadge :color="entity.extended_schedule ? 'success' : 'secondary'">
                    {{ entity.extended_schedule ? "Включено" : "Отключено" }}
                </CBadge>
            </span>
        </div>

        <Schedule class="font-bold" :schedule="schedule" />

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Открывается при клике</span>
            <span class="w-2/3">{{ typesMap[entity.type] }}</span>
        </div>

        <div v-if="entity.type === 'link' || entity.type === 'external_link'" class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Ссылка</span>
            <span class="w-2/3">{{ entity.link }}</span>
        </div>

        <div v-if="entity.type === 'list'" class="flex items-center mt-4">
            <span class="w-1/3 font-bold">{{ routeNamesMap[entity.route_name] }}</span>
            <span class="w-2/3" v-html="entities"></span>
        </div>

        <div v-if="entity.type === 'product_detail'">
            <div class="flex items-center mt-4">
                <span class="w-1/3 font-bold">Партнер</span>
                <span class="w-2/3">{{ getPartnerName() }}</span>
            </div>
            <div class="flex items-center mt-4">
                <span class="w-1/3 font-bold">Продукт</span>
                <span class="w-2/3">{{ productDetail ? productDetail.title : 'Не выбран' }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    const { formatDate } = require('../../utils/views');
    import Schedule from '@/components/Schedule';

    export default {
        components: {
            Schedule,
        },
        props: {
            entity: {
                type: Object,
                default: () => {},
            },
        },

        data: () => ({
            schedule: undefined,
            banner: {
                extended_schedule: false,
            },
            contentTypesMap: {
                'image': 'Изображение центрированое',
                'image_bg': 'Изображение как фон',
                'video_mp4': 'Видео в формате mp4',
                'video_webm': 'Видео в формате webm',
            },
            typesMap: {
                'none': 'Ничего',
                'link': 'Ссылка на страницу',
                'external_link': 'Внешняя ссылка',
                'list': 'Список бизнесов',
                'products_list': 'Список блюд',
                'product_detail': 'Продукт',
                'stories': 'Сторис',
            },
            routeNamesVar: {
                'restaurant-list': 'restaurants',
                'grocery-list': 'grocers',
                'pharmacy-list': 'pharmacies',
                'assistant-list': 'assistants',
            },
            routeNamesMap: {
                'restaurant-list': 'Список ресторанов',
                'grocery-list': 'Список продуктовых магазинов',
                'pharmacy-list': 'Список аптек',
                'assistant-list': 'Список помощников',
            },
            restaurants: [],
            grocers: [],
            pharmacies: [],
            assistants: [],
            allEntities: {},
            productDetail: null,
        }),

        computed: {
            entities() {
                return this[this.routeNamesVar[this.entity.route_name]] ? this[this.routeNamesVar[this.entity.route_name]].filter(el => {
                    return this.entity.list.includes(el.id);
                }).map(el => {
                    return el.title
                }).join('<br>') : '';
            },
        },

        async created() {
            const { data: restaurants } = await Vue.axios.get('/restaurants');
            this.restaurants = restaurants;
            const { data: grocers } = await Vue.axios.get('/grocers');
            this.grocers = grocers;
            const { data: pharmacies } = await Vue.axios.get('/pharmacies');
            this.pharmacies = pharmacies;
            const { data: assistants } = await Vue.axios.get('/assistants');
            this.assistants = assistants;
            
            // Загружаем все entity types для поддержки product_detail с entities
            const { data: entityTypes } = await Vue.axios.get('/entities-type');
            await Promise.all(entityTypes.map(async type => {
                const entities = await Vue.axios.get(`/entities/${type.code}`);
                this.$set(this.allEntities, type.code, {
                    title: type.title,
                    items: entities?.data?.length ? entities.data : []
                });
            }));
        },

        async mounted() {
            const id = this.$route.params.id;
            try {
                const resp = await Vue.axios.get('/banners/' + id);
                this.banner = resp.data;
                if(resp.data.schedule.length != 0) {
                    this.schedule = resp.data.schedule;
                }
                
                // Загружаем детали продукта для product_detail
                if (this.entity.type === 'product_detail' && this.entity.product_id) {
                    await this.loadProductDetail();
                }
            } catch (e) {
                this.$root.$emit('showError', 'Ошибка загрузки данных. ' + e.message);
            }
        },

        methods: {
            formatDate(date) {
                return formatDate(date);
            },
            pictureUrl(picture) {
                return picture ? (process.env.VUE_APP_STATIC_BASE_URL + '/' + picture) : '';
            },
            noneZero(date) {
                return (date === 0 ? '' : date);
            },
            async loadProductDetail() {
                let serviceType = 'restaurants'; // default
                
                // Используем сохраненный service_type, если есть (преобразуем из единственного во множественное)
                if (this.entity.service_type) {
                    serviceType = this.serviceTypeToPlural(this.entity.service_type);
                }
                // Если service_type не сохранен, определяем динамически
                else if (this.entity.entity_id_for_product) {
                    const entityId = this.entity.entity_id_for_product;
                    
                    // Проверяем в restaurants
                    if (this.restaurants.find(r => r.id === entityId)) {
                        serviceType = 'restaurants';
                    }
                    // Проверяем в grocers
                    else if (this.grocers.find(g => g.id === entityId)) {
                        serviceType = 'grocers';
                    }
                    // Проверяем в pharmacies
                    else if (this.pharmacies.find(p => p.id === entityId)) {
                        serviceType = 'pharmacies';
                    }
                    // Если не найдено, пробуем entities
                    else {
                        serviceType = 'entities';
                    }
                }
                
                try {
                    const items = await Vue.axios.get(`/${serviceType}/products/items`, { 
                        params: { ids: JSON.stringify([this.entity.product_id]) } 
                    });
                    if (items.data && items.data.length > 0) {
                        this.productDetail = items.data[0];
                    }
                } catch (err) {
                    console.log('Cannot load product detail.', err);
                }
            },
            serviceTypeToPlural(singularType) {
                const map = {
                    'restaurant': 'restaurants',
                    'grocer': 'grocers',
                    'pharmacy': 'pharmacies',
                    'entity': 'entities'
                };
                return map[singularType] || singularType;
            },
            getServiceType() {
                switch (this.entity.route_name) {
                    case 'restaurant-list':
                        return 'restaurants';
                    case 'grocery-list':
                        return 'grocers';
                    case 'pharmacy-list':
                        return 'pharmacies';
                    case 'assistant-list':
                        return 'assistants';
                    default:
                        return 'entities';
                }
            },
            getPartnerName() {
                if (!this.entity.entity_id_for_product) return 'Не выбран';
                
                const entityId = this.entity.entity_id_for_product;
                const serviceType = this.entity.service_type;
                
                // Используем service_type для определения типа партнера
                if (serviceType === 'restaurant') {
                    const restaurant = this.restaurants.find(r => r.id === entityId);
                    return restaurant ? `[Ресторан] ${restaurant.title}` : 'Не найден';
                } else if (serviceType === 'grocer') {
                    const grocer = this.grocers.find(g => g.id === entityId);
                    return grocer ? `[Магазин] ${grocer.title}` : 'Не найден';
                } else if (serviceType === 'pharmacy') {
                    const pharmacy = this.pharmacies.find(p => p.id === entityId);
                    return pharmacy ? `[Аптека] ${pharmacy.title}` : 'Не найден';
                } else if (serviceType === 'entity') {
                    // Для entities ищем во всех динамических типах
                    for (const typeKey in this.allEntities) {
                        const entityData = this.allEntities[typeKey];
                        const entity = entityData.items.find(e => e.id === entityId);
                        if (entity) {
                            return `[${entityData.title}] ${entity.title}`;
                        }
                    }
                    return 'Не найден';
                }
                
                // Резервный вариант - если service_type не указан, пробуем определить автоматически
                const restaurant = this.restaurants.find(r => r.id === entityId);
                if (restaurant) return `[Ресторан] ${restaurant.title}`;
                
                const grocer = this.grocers.find(g => g.id === entityId);
                if (grocer) return `[Магазин] ${grocer.title}`;
                
                const pharmacy = this.pharmacies.find(p => p.id === entityId);
                if (pharmacy) return `[Аптека] ${pharmacy.title}`;
                
                const assistant = this.assistants.find(a => a.id === entityId);
                if (assistant) return `[Помощник] ${assistant.title}`;
                
                // Ищем в entities
                for (const typeKey in this.allEntities) {
                    const entityData = this.allEntities[typeKey];
                    const entity = entityData.items.find(e => e.id === entityId);
                    if (entity) {
                        return `[${entityData.title}] ${entity.title}`;
                    }
                }
                
                return 'Не найден';
            },
        },
    };
</script>
